import React from 'react';
import SearchSection from './SearchSection.jsx';
import ShiftSection from './ShiftSection.jsx';
import HowItWorksSection from './HowItWorksSection.jsx';
import PartnersSection from './PartnersSection.jsx';
import { SHIFT_TYPES } from '../Constants';

/** Component for Locumly Home. */
const HomePage = () => {
  return (
    <article className={'home-page'}>
      <SearchSection />
      <ShiftSection shiftType={SHIFT_TYPES.OPTOMETRY.key} />
      <HowItWorksSection />
      <PartnersSection />
    </article>
  );
};

export default HomePage;